
// buildHistory
// UAT --> uat | 3.0.5"
// LIVE --> 2.0.5

// export const buildVersion = "uat | 1.0.0";
export const buildVersion = "prod | 1.0.0";
